import {
    TC_ID_UPDATED,
    TC_UPDATED,
    TC_INVALIDATED,
    TC_URATE_UPDATED,
    TC_UCRATE_UPDATED,
    TC_CRATE_UPDATED,
    TC_UTC_UPDATED,
    TC_UNSAVED_ADD,
    TC_UNSAVED_DELETE,
    TC_UNSAVED_CLEAR,
} from "../Constants/tcConstants.js";

const tcReducer = (state = { unsaveds: {} , tcid: null, analysis: null, tc: null, gtc: null, comp: null, ucomp: null}, action) => {
    switch(action.type) {
        case TC_URATE_UPDATED:
            return {
                ...state,
                gtc: action.payload,
            }
        case TC_CRATE_UPDATED:
            return {
                ...state,
                comp: action.payload,
            }
        case TC_UCRATE_UPDATED:
            return {
                ...state,
                ucomp: action.payload,
            }
        case TC_UTC_UPDATED:
            return {
                ...state,
                tc: action.payload,
            }
        case TC_ID_UPDATED:
            return {
                ...state,
                tcid: action.payload.tcid,
                tc: null,
                gtc: null,
                comp: null,
                analysis: null,
                ucomp: null,
            }
        case TC_UPDATED:
            let newState = {
                ...state,
                tcid: action.payload.usertc._id,
                tc: action.payload.usertc,
                analysis: action.payload.analysis,
            };

            if (action.payload.gentc){
                newState.gtc = action.payload.gentc;
            } else {
                newState.gtc = null;
            }

            if (action.payload.company){
                newState.comp = action.payload.company;
            } else {
                newState.comp = null;
            }
            
            if (action.payload.ucomp){
                newState.ucomp = action.payload.ucomp;
            } else {
                newState.ucomp = null;
            }
            return newState;
        case TC_INVALIDATED:
            return {
                ...state,
                tc: null,
                tcid: null,
                gtc: null,
                comp: null,
                analysis: null,
                ucomp: null,
            }
        case TC_UNSAVED_ADD:
            let usAdded = {...(state.unsaveds)};

            usAdded[action.payload.tcid] = action.payload.token;
            
            return {
                ...state,
                unsaveds: usAdded,
            }

        case TC_UNSAVED_DELETE:
            let usDeleted = {...(state.unsaveds)};
            
            if (usDeleted.hasOwnProperty(action.payload.tcid)){
                delete usDeleted[action.payload.tcid];
            }
            
            return {
                ...state,
                unsaveds: usDeleted,
            }
        case TC_UNSAVED_CLEAR:
            return {
                ...state,
                unsaveds: {},
            }
        default:
            return state;
    }
};

export { tcReducer };